import { formatDate } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OtpVerifyComponent } from "src/app/shared-modules/otp-verify/otp-verify.component";
import { CorporateDeleteAccountComponent } from "../corporate-delete-account/corporate-delete-account.component";
import { CorporateService } from "../corporate.service";

@Component({
  selector: "app-corporate-profile",
  templateUrl: "./corporate-profile.component.html",
  styleUrls: ["./corporate-profile.component.css"],
})
export class CorporateProfileComponent implements OnInit {
  profileLoading: boolean = false;
  public editGeneralInfo = false;
  public editBillingDetails = false;
  public mobileVerified = 0;
  public emailVerified = 0;
  public updateBtn = true;
  public profileUpdate = "NA";
  public profileUpdateButton = false;
  public billingSave = false;
  public save = false;
  public edit1 = true;
  public edit2 = true;
  profileForm!: FormGroup;
  billingForm!: FormGroup;
  maxDate = new Date();
  file: any = "";
  profileImage: any = "";
  dateFormat = "yyyy-MM-dd";
  language = "en";
  loading: boolean = false;
  token: any;
  invalidDate: boolean = false;
  matDialogref: MatDialogRef<OtpVerifyComponent> | undefined;
  MatDialogref: MatDialogRef<CorporateDeleteAccountComponent>;

  data = {
    username: "",
    mobile: 0,
    email: "",
    dob: new Date(),
    gender: "",
    company_name: "",
    profile_pic: "",
    designation: "",
    gst: ["", Validators.compose([Validators.pattern("[A-Z0-9]{15}")])],
    billing_address: {
      username: "",
      address_line: "",
      area_name: "",
      city: "",
      state: "",
      pincode: "",
      mobile: "",
      gst: ["", Validators.compose([Validators.pattern("[A-Z0-9]{15}")])],
      landmark: "",
    },
  };

  emailregex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;

  constructor(
    private router: Router,
    private services: CorporateService,
    private matDialog: MatDialog,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("corporate_token");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    this.profileForm = this.formBuilder.group({
      userName: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      email: ["", Validators.compose([Validators.pattern(this.emailregex)])],
      dateOfBirth: [""],
      gender: [""],
      companyName: ["", [Validators.pattern("^[A-Za-z0-9? ,_-]+$")]],
      designation: [""],
      gst: ["", Validators.compose([Validators.pattern("[A-Z0-9]{15}")])],
    });
    this.billingForm = this.formBuilder.group({
      billingName: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      billingContact: [
        "",
        [Validators.required, Validators.pattern("^[0-9]{10,10}$")],
      ],
      address: ["", [Validators.required]],
      area: ["", [Validators.required]],
      city: ["", [Validators.required]],
      state: ["", [Validators.required]],
      pincode: ["", [Validators.required, Validators.pattern("^[0-9]{6,6}$")]],
      gst: ["", Validators.compose([Validators.pattern("[A-Z0-9]{15}")])],
    });
    this.getProfile();
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
  }

  public get ProfileFormControl() {
    return this.profileForm.controls;
  }
  public get BillingFormControl() {
    return this.billingForm.controls;
  }

  public formatFormDate(date: Date) {
    return formatDate(date, this.dateFormat, this.language);
  }

  public getProfile(): void {
    let token = sessionStorage.getItem("corporate_token");
    this.services.GetProfile(token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          if (
            response.body.data.billing_address === null ||
            response.body.data.billing_address === undefined
          ) {
            response.body.data.billing_address = {};
            this.data = response.body.data;
          } else {
            this.data = response.body.data;
          }
          this.profileImage = response.body.data.profile_pic;
          this.mobileVerified = response.body.data.mobile_verified;
          this.emailVerified = response.body.data.email_verified;
        }
      },
      (error) => {
        if (error.status === 401) {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  public onEditProfile(num: number): void {
    this.updateBtn = false;
    this.profileUpdateButton = true;
    this.save = true;
    this.edit1 = false;
    this.edit2 = false;
    if (!this.editGeneralInfo) {
      this.ProfileFormControl["userName"].setValue(this.data.username);
      this.ProfileFormControl["mobile"].setValue(this.data.mobile);
      this.ProfileFormControl["email"].setValue(this.data.email);
      this.ProfileFormControl["companyName"].setValue(this.data.company_name);
      this.ProfileFormControl["designation"].setValue(this.data.designation);
      this.ProfileFormControl["dateOfBirth"].setValue(this.data.dob);
      this.ProfileFormControl["gender"].setValue(this.data.gender);
      this.ProfileFormControl["gst"].setValue(this.data.gst);
      if (this.data.dob != null) {
        this.profileForm.patchValue({
          dateOfBirth: this.formatFormDate(this.data.dob),
        });
      }
    }
    if (num === 1) {
      this.editGeneralInfo = true;
    }
  }
  onEditBillingAddress() {
    this.billingSave = true;
    this.profileUpdateButton = false;
    this.save = false;
    this.edit1 = false;
    this.edit2 = false;
    this.editBillingDetails = true;
    if (this.editBillingDetails) {
      this.BillingFormControl["billingName"].setValue(
        this.data.billing_address.username
      );
      this.BillingFormControl["address"].setValue(
        this.data.billing_address.address_line
      );
      this.BillingFormControl["area"].setValue(
        this.data.billing_address.area_name
      );
      this.BillingFormControl["city"].setValue(this.data.billing_address.city);
      this.BillingFormControl["state"].setValue(
        this.data.billing_address.state
      );
      this.BillingFormControl["pincode"].setValue(
        this.data.billing_address.pincode
      );
      this.BillingFormControl["billingContact"].setValue(
        this.data.billing_address.mobile
      );
      this.BillingFormControl["gst"].setValue(this.data.billing_address.gst);
    }
  }

  public onChange(event: any): void {
    this.profileLoading = true;
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        this.profileLoading = false;
        var imgType = this.file.type.split("/");
        if (response.status === 201) {
          if (
            imgType[1] === ".jpg" ||
            imgType[1] === "png" ||
            imgType[1] === "jpeg"
          ) {
            this.profileImage = response.body.image_link;
            this.snackBar.open("File Added Successfully", "Success", {
              duration: 5000,
            });
            return;
          } else {
            this.snackBar.open(
              "Please upload only JPG or PNG or JPEG type file",
              "Fail",
              {
                duration: 5000,
              }
            );
          }
        }
      },
      (error) => {
        if (error.status === 401) {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public updateProfile(): void {
    if (this.profileForm.valid) {
      this.loading = true;
      this.profileUpdate = "NA";
      let token = sessionStorage.getItem("corporate_token");
      const profileData = {
        username: this.ProfileFormControl["userName"].value,
        mobile: this.ProfileFormControl["mobile"].value,
        email: this.ProfileFormControl["email"].value,
        dob: this.ProfileFormControl["dateOfBirth"].value,
        gender: this.ProfileFormControl["gender"].value,
        company_name: this.ProfileFormControl["companyName"].value,
        profile_pic: this.profileImage,
        designation: this.ProfileFormControl["designation"].value,
        gst: this.ProfileFormControl["gst"].value,
      };
      this.services.UpdateProfile(profileData, token).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.data = response.body.data;
            this.profileImage = response.body.data.profile_pic;
            this.mobileVerified = response.body.data.mobile_verified;
            this.emailVerified = response.body.data.email_verified;
            this.editBillingDetails = false;
            this.editGeneralInfo = false;
            this.profileUpdateButton = false;
            this.save = false;
            this.edit1 = true;
            this.edit2 = true;
            sessionStorage.setItem("corporateProfilePic", this.profileImage);
            sessionStorage.setItem("corporateUserName", this.data.username);
            this.profileUpdate = "success";
          }
        },
        (error) => {
          if (error.status === 401) {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
      this.updateBtn = false;
      this.getProfile();
    } else {
      this.invalidDate = false;
      if (this.ProfileFormControl["dateOfBirth"].value > this.maxDate) {
        this.invalidDate = true;
      }
      this.profileForm.markAllAsTouched();
    }
  }

  updateBillingAddress() {
    if (this.billingForm.valid) {
      this.loading = true;
      let token = sessionStorage.getItem("corporate_token");
      const billingData = {
        billing_address: {
          username: this.BillingFormControl["billingName"].value,
          address_line: this.BillingFormControl["address"].value,
          area_name: this.BillingFormControl["area"].value,
          city: this.BillingFormControl["city"].value,
          state: this.BillingFormControl["state"].value,
          pincode: this.BillingFormControl["pincode"].value,
          mobile: this.BillingFormControl["billingContact"].value,
          gst: this.BillingFormControl["gst"].value,
          landmark: "",
        },
      };
      this.services.UpdateProfile(billingData, token).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.data = response.body.data;
            this.editBillingDetails = false;
            this.profileUpdateButton = false;
            this.save = false;
            this.billingSave = false;
            this.edit1 = true;
            this.edit2 = true;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
      this.getProfile();
    } else {
      this.billingForm.markAllAsTouched();
    }
  }

  public SendOtp(): void {
    const dataValue = {
      email: this.data.email,
      displayText: "Email Address",
    };
    this.matDialogref = this.matDialog.open(OtpVerifyComponent, {
      width: "500px",
      data: {
        dataKey: dataValue,
      },
      autoFocus: false,
    });

    this.matDialog._getAfterAllClosed().subscribe((result: any) => {
      this.emailVerified = 1;
    });
  }
  GoToDashboard() {
    this.router.navigateByUrl("/corporate/dashboard");
  }
  deleteaccount(item: any) {
    this.MatDialogref = this.matDialog.open(CorporateDeleteAccountComponent, {
      width: "500px",
      data: item,
      autoFocus: false,
    });
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }

  onPasteNumber(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    if (!/^[0-9]+$/.test(pastedText)) {
      event.preventDefault();
    }
  }
}
